import { Reducer, AnyAction } from 'redux';
import { StatePathType } from 'app/constants';
import { ACTION, RequestCodetable, ReceiveCodetable, FailCodetable } from './action-types';
import { OptionsState } from './types';

const reducers: { [indexer: string]: Reducer<OptionsState> } = {

  /**
   * Run when a component wants codetable data
   */
  [ACTION.REQUEST_CODETABLE]: (state: OptionsState, action: RequestCodetable): OptionsState => {
    return {
      ...state,
      options: {
        ...(state.options || {}),
        [action.id]: {
          query: action.query,
          fetching: true,
          loadOptionsParams: action.loadOptionsParams,
          codes: undefined
        }
      }
    };
  },

  /**
   * Run when a component receives its code data
   */
  [ACTION.RECEIVE_CODETABLE]: (state: OptionsState, action: ReceiveCodetable): OptionsState => {
    if (!state.options || !state.options[action.id] || state.options[action.id].query !== action.query) {
      return state;
    }

    return {
      ...state,
      options: {
        ...(state.options || {}),
        [action.id]: {
          ...state.options[action.id],
          query: action.query,
          codes: action.values,
          fetching: false
        }
      }
    };
  },

  /**
   * Run when a component fails to download codetable data
   */
  [ACTION.FAIL_CODETABLE]: (state: OptionsState, action: FailCodetable): OptionsState => {

    if (!state.options || !state.options[action.id] || state.options[action.id].query !== action.query) {
      return state;
    }

    return {
      ...state,
      options: {
        ...(state.options || {}),
        [action.id]: {
          ...state.options[action.id],
          fetching: false
        }
      }
    };
  }
};

export const withOptionsReducer = <S>(path: StatePathType, reducer: Reducer<S>) =>
  (state: S, action: AnyAction) => {
    const r = action.path === path && reducers[action.type];
    return ((r && r(state as any, action)) || reducer(state, action)) as S;
  };
